export { default as Article } from './Article'
export { default as Community } from './Community'
export { default as Discover } from './Discover'
//export { default as NewCamp } from './NewCamp'
export { default as PasswordRequest } from './PasswordRequest'
export { default as PasswordReset } from './PasswordReset'
export { default as Profile } from './Profile'
export { default as Registration } from './Registration'
export { default as Search } from './Search'
export { default as Signup } from './Signup'
export { default as Statement } from './Statement'
export { default as Verification } from './Verification'
export { default as Video } from './Video'
export { default as Workshop } from './Video'
export { default as PageNotFound } from './PageNotFound'


// WEBPACK FOOTER //
// ./src/js/views/index.js